import { useMemo, useState } from 'react'

import type { ProtobufAnyMessage } from '@/types'
import { UiButton } from '@/ui/UiButton'
import {
  UiCard,
  UiCardContent,
  UiCardDescription,
  UiCardHeader,
  UiCardTitle,
} from '@/ui/UiCard'
import {
  UiCollapsible,
  UiCollapsibleContent,
  UiCollapsibleTrigger,
} from '@/ui/UiCollapsible'

type Props = {
  message: ProtobufAnyMessage
}

export default function ProposalMessageCard({ message }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const typeUrl = String(message['@type'] ?? '')

  const prettyJson = useMemo(() => {
    try {
      return JSON.stringify(message, null, 2)
    } catch {
      return String(message)
    }
  }, [message])

  return (
    <UiCard>
      <UiCardHeader className='pb-3'>
        <UiCardTitle className='text-sm'>Message</UiCardTitle>
        <UiCardDescription className='font-mono break-all'>
          {typeUrl}
        </UiCardDescription>
      </UiCardHeader>

      <UiCardContent>
        <UiCollapsible open={isOpen} onOpenChange={setIsOpen}>
          <div className='flex items-center justify-end'>
            <UiCollapsibleTrigger asChild>
              <UiButton type='button' variant='outline2' size='sm'>
                {isOpen ? 'Hide JSON' : 'Show JSON'}
              </UiButton>
            </UiCollapsibleTrigger>
          </div>

          <UiCollapsibleContent className='mt-3'>
            <pre className='bg-muted/30 text-foreground max-h-[360px] overflow-auto rounded-md p-4 text-xs leading-relaxed'>
              {prettyJson}
            </pre>
          </UiCollapsibleContent>
        </UiCollapsible>
      </UiCardContent>
    </UiCard>
  )
}
